import React from 'react';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const RicosContext = React.createContext({
  locale: "en",
  localeContent: "en",
  experiments: {},
  isMobile: false,
  t: (text) => text,
  languageDir: "ltr",
  theme: {},
  portal: null,
  debugMode: [],
  platform: "macOs",
  content: null,
  jsdomMode: false,
  environment: "liveSite",
  tabIndex: 0
});
const RicosContextProvider = ({
  children,
  isMobile,
  locale,
  localeContent,
  experiments,
  languageDir,
  theme,
  t,
  portal,
  editorExternalContainer,
  debugMode = [],
  jsdomMode = false,
  platform = "macOs",
  content = null,
  environment = "liveSite",
  tabIndex = 0
}) => {
  return /* @__PURE__ */ React.createElement(
    RicosContext.Provider,
    {
      value: {
        t,
        locale,
        localeContent,
        isMobile,
        experiments: experiments != null ? experiments : {},
        languageDir,
        theme,
        portal: portal != null ? portal : null,
        debugMode,
        jsdomMode,
        editorExternalContainer,
        platform,
        content,
        environment,
        tabIndex
      }
    },
    children
  );
};
function withRicosContext(Component) {
  return (props) => {
    return /* @__PURE__ */ React.createElement(RicosContext.Consumer, null, (value) => /* @__PURE__ */ React.createElement(Component, __spreadProps(__spreadValues({}, props), { ricosContext: value })));
  };
}
const RicosContextConsumer = ({ children }) => {
  return /* @__PURE__ */ React.createElement(RicosContext.Consumer, null, (value) => children(value));
};

export { RicosContext, RicosContextConsumer, RicosContextProvider, withRicosContext };
//# sourceMappingURL=RicosContext.js.map
